import React, { useEffect, useState } from 'react';
import WeeklyCalendar from '../../../components/weekly-calendar/WeeklyCalendar';
import Calendar from '../../../components/Calendar/Calendar';
import { useUniversalFind } from '../../../hooks/universal';
import { format } from 'date-fns';
import { Appointments, EventType } from '../../../misc/types';
import { accessGlobalUserState } from '../../../stores/user';
import { updateLocalStateRaw, userHasRole } from '../../../misc/utils';
import { psychologistTabs } from '../../../misc/constants';
import { PsychologyAdmin } from './PsychologyAdmin';
import { useHookstate } from '@hookstate/core';
import { useGlobalMiscState } from '../../../stores/misc';
import { PsychologyList } from './PsychologyList';
const Psychology = () => {
  const miscState = useGlobalMiscState();
  const userState = accessGlobalUserState()
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const currentTab = state.currentTab || "calendar";
  const user = userState.get()
  const uniqUser = user.uniqUser || {}
  const [localEvents, setLocalEvents] = useState<EventType[]>([]);
  const isAdmin = userHasRole('psychologist_admin')
  const psychologyCalendarTriggerFetch = miscState.get('psychologyCalendarTriggerFetch') || 0;

  const updateTab = (key: string) => () => {
    updateLocalStateRaw(localState, 'currentTab')(key)
  }

  const setUpdatedAppointments = (newAppointments: any[]) => {
    const updated = newAppointments.map((appointment) => {
      const clients = appointment.clients
        .filter((c: any) => [-1, 0, 1, 2].includes(c.status))
        .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      const client = clients[0]?.client_user;
      const first = client?.json_saved_data?.firstname || '';
      const last = client?.json_saved_data?.lastname || '';
      const body: EventType = {
        id: appointment.id,
        title: client
          ? `${first} ${last}`.trim() || 'Занято'
          : 'Свободное время',
        start: format(new Date(appointment.start_time), 'HH:mm'),
        end: format(new Date(appointment.end_time), 'HH:mm'),
        day: new Date(appointment.start_time),
        canceled: appointment.status === -1,
      };
      if (client) {
        body.client = client.json_saved_data;
        body.clientSelf = clients[0];
      }
      return body;
    });
    console.log(updated)
    setLocalEvents(updated)
  }

  const appointments = useUniversalFind(
    'PsychologistAppointment',
    {
      main_user_id: uniqUser.id
    },
    {
      include: [
        {
          model: 'PsychologistAppointmentClient',
          as: 'clients',
          include: ['client_user'],
        },
      ],
    },
    psychologyCalendarTriggerFetch,
    setUpdatedAppointments
  ) as Appointments | null;

  const eventsFromServer = React.useMemo(() => {
    if (!appointments || !Array.isArray(appointments)) return [];
    return appointments.map((appointment) => {
      const clients = appointment.clients
        .filter(c => [-1, 0, 1, 2].includes(c.status))
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      const client = clients[0]?.client_user;
      const first = client?.json_saved_data?.firstname || '';
      const last = client?.json_saved_data?.lastname || '';
      const body: EventType = {
        id: appointment.id,
        title: client
          ? `${first} ${last}`.trim() || 'Занято'
          : 'Свободное время',
        start: format(new Date(appointment.start_time), 'HH:mm'),
        end: format(new Date(appointment.end_time), 'HH:mm'),
        day: new Date(appointment.start_time),
        canceled: appointment.status === -1,
      };
      if (client) {
        body.client = client.json_saved_data;
        body.clientSelf = clients[0];
      }
      return body;
    });
  }, [appointments]);

  useEffect(() => {
    setLocalEvents(eventsFromServer);
  }, [eventsFromServer.length]);

  return (
    <div className="bg-[#f8f9fd] h-full text-black p-5 text-sm flex flex-col gap-4 overflow-y-auto">
      <div className="flex flex-row self-start bg-white rounded-xl p-2 gap-3">
        {psychologistTabs.map(t => {
          const isActive = currentTab === t.key;
          const Icon = t.icon;
          return (
            <div key={t.key} className={`flex flex-row ${isActive && 'bg-valley-main'} gap-[6px] px-2 py-1.5 items-center rounded-lg cursor-pointer`} onClick={updateTab(t.key)}>
              <Icon additionalStyle={isActive ? 'text-white' : 'text-valley-main'} />
              <span className={`font-medium leading-[19.2px] ${isActive ? 'text-white' : 'text-valley-black'}`}>
                {t.label}
              </span>
            </div>
          )
        })}
      </div>
      <div className='flex flex-row gap-4 flex-1 overflow-y-auto'>
        {currentTab === "calendar" && (
          <React.Fragment>
            <Calendar localEvents={localEvents} />
            <WeeklyCalendar localEvents={localEvents} setLocalEvents={setLocalEvents} />Z
          </React.Fragment>
        )}
        {currentTab === "list" && (
          <React.Fragment>
            <Calendar localEvents={localEvents} />
            <PsychologyList localEvents={localEvents} />
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default Psychology;
